import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const fetchTaxSetting = ({commit}) => {

    commit('toggleLoadingState', true)

    axios.get('/taxSetting/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        commit('setTaxSetting', res.data.response)                  

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitTaxSetting = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/taxSetting/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Submitted successfully!!!'});
            dispatch('fetchPreferences')
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/taxSetting/actions.js